import { createReducer, on } from '@ngrx/store';
import { designerUpdateMappingFields } from './mappings.actions';

export const mappingsReducer = createReducer(
  [],
  on(designerUpdateMappingFields, (_, action) => [...action.mappings]),
);
